import { DText, Flex } from '../../../../../styles/CommonStyles'
import Text from '../../../../../core/utils/Text'
import DateTime from '../../../../common/utils/DateTime'
import UserLink from '../../../../common/utils/UserLink'
import RTableLayout from '../../../../responsive/layout/RTableLayout'
import Operation from '../../../../common/utils/Operation'
import { useNavigate } from 'react-router-dom'

const RRecipientsTable = ({ data }) => {
    const { data: recipients } = data
    const navigate = useNavigate()

    return (
        <RTableLayout data={data}>
            {recipients?.data?.map((item) => {
                const label = item.label
                const fullName = item.userId

                const isActive = item.meta?.isActive

                return (
                    <div
                        key={item._id}
                        style={{
                            border: '1px solid #eee',
                            borderRadius: 12,
                            padding: 12,
                            marginBottom: 12
                        }}
                    >
                        {/* HEADER */}
                        <Flex justify="space-between">
                            <UserLink
                                _id={item.userId}
                                name={fullName}
                            />

                            <Operation
                                hasDetails
                                onDetailsClicked={() =>
                                    navigate(
                                        `/reports/due-payments/recipients/${item._id}`
                                    )
                                }
                            />
                        </Flex>

                        {/* LABEL */}
                        <Flex justify="space-between">
                            <DText fontSize="s" main>
                                <Text tid="label" />
                            </DText>
                            <DText fontSize="s" main>
                                <Text tid={label} />
                            </DText>
                        </Flex>

                        {/* ACCOUNT ID */}
                        <Flex justify="space-between">
                            <DText fontSize="s" main>
                                <Text tid="account-id" />
                            </DText>
                            <DText fontSize="s" main>
                                <Text tid={item.accountId} />
                            </DText>
                        </Flex>


                        {/* STATUS */}
                        <Flex justify="space-between">
                            <DText fontSize="s" main>
                                <Text tid="status" />
                            </DText>
                            <DText fontSize="s" main>
                                <Text tid={isActive ? 'active' : 'inactive'} />
                            </DText>
                        </Flex>

                        {/* CREATED AT */}
                        <Flex justify="space-between">
                            <DText fontSize="s" main>
                                <Text tid="created-at" />
                            </DText>
                            <DateTime dt={item.createdAt} />
                        </Flex>
                    </div>
                )
            })}
        </RTableLayout>
    )
}

export default RRecipientsTable